/**
 * Nội dung thanh toán
 */
export default {
  DescriptionGeneral: 'journal_memo', // Diễn giải chứng từ
  DetailInOneLine: 'detail_in_one_line', // Diễn giải chứng từ
  BudgetItemName: 'budget_item_name', // Tên mục
  BudgetSubItemName: 'budget_sub_item_name', // Tên tiểu mục
};
